import { defineNuxtPlugin, useRuntimeConfig } from "#app";
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig();
  return {
    provide: {
      /**
       * Creates an absolute URL to the specified web path on the SPOFERAN app if on an external service,
       * or a relative web path if on the SPOFERAN app itself.
       */
      spoferanUrl: (path = "/") => {
        const locale = !nuxtApp.i18n || nuxtApp.i18n.locale === nuxtApp.i18n.defaultLocale ? null : nuxtApp.i18n.locale;
        const cleanPath = path.startsWith("/") ? path.substring(1) : path;
        if (!config.public.isSpoferanDomain) {
          const spoferanUrl = config.public.spoferanUrl;
          let absoluteUrl = spoferanUrl.endsWith("/") ? spoferanUrl.slice(0, -1) : spoferanUrl;
          absoluteUrl += `/` + (locale ? `${locale}/` : "") + cleanPath;
          return encodeURI(absoluteUrl);
        }
        return (locale ? `/${locale}/` : "/") + encodeURI(cleanPath);
      }
    }
  };
});
